import React from "react";
import { Link } from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Button,
  UncontrolledCollapse,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

import { MultiLang, Determinator } from "react-multi-language";

class DemoNavbar extends React.Component {
  componentDidMount() {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    headroom.init();
  }
  state = {
    collapseClasses: "",
    collapseOpen: false
  };

  onExiting = () => {
    this.setState({
      collapseClasses: "collapsing-out"
    });
  };

  onExited = () => {
    this.setState({
      collapseClasses: ""
    });
  };

  render() {
    return (
      <>
        {console.log("..[log - Navbar.js, languageState] : ", this.props.languageState)}
        <header className="header-global">
          <Navbar
            className="navbar-main navbar-transparent navbar-light headroom"
            expand="lg"
            id="navbar-main"
          >
            <Container>
              <NavbarBrand className="mr-lg-5" to="/" tag={Link}>
                <img
                  alt="..."
                  src={require("assets_/img_/brand/clc-white.png")}
                />
              </NavbarBrand>
              <button className="navbar-toggler" id="navbar_global">
                <span className="navbar-toggler-icon" />
              </button>
              <UncontrolledCollapse
                toggler="#navbar_global"
                navbar
                className={this.state.collapseClasses}
                onExiting={this.onExiting}
                onExited={this.onExited}
              >
                <div className="navbar-collapse-header">
                  <Row>
                    <Col className="collapse-brand" xs="6">
                      <Link to="/">
                        <img
                          alt="..."
                          src={require("assets_/img_/brand/clc.png")}
                        />
                      </Link>
                    </Col>
                    <Col className="collapse-close" xs="6">
                      <button className="navbar-toggler" id="navbar_global">
                        <span />
                        <span />
                      </button>
                    </Col>
                  </Row>
                </div>


                <Nav className="navbar-nav-hover align-items-lg-center" navbar>
                  <UncontrolledDropdown nav>
                    <DropdownToggle nav>
                      <i className="ni ni-collection d-lg-none mr-1" />
                      <Link className="text-grey" to="/">
                        <span className="nav-link-inner--text">
                          <Determinator>
                            {{
                              en: "About CLC",
                              tw: "關於CLC",
                              cn: "关於CLC",
                            }}
                          </Determinator>
                        </span>
                      </Link>
                    </DropdownToggle>
                  </UncontrolledDropdown>
                  <UncontrolledDropdown nav>
                    <DropdownToggle nav>
                      <i className="ni ni-collection d-lg-none mr-1" />
                      <Link className="text-grey" to="/events">
                        <span className="nav-link-inner--text">
                          <Determinator>
                            {{
                              en: "Events",
                              tw: "活動",
                              cn: "活动",
                            }}
                          </Determinator>
                        </span>
                      </Link>
                    </DropdownToggle>
                  </UncontrolledDropdown>
                  <UncontrolledDropdown nav>
                    <DropdownToggle nav>
                      <i className="ni ni-collection d-lg-none mr-1" />
                      <Link className="text-grey" to="/venue">
                        <span className="nav-link-inner--text">
                          <Determinator>
                            {{
                              en: "Venue",
                              tw: "場地",
                              cn: "场地",
                            }}
                          </Determinator>
                        </span>
                      </Link>
                    </DropdownToggle>
                  </UncontrolledDropdown>
                  <UncontrolledDropdown nav>
                    <DropdownToggle nav>
                      <i className="ni ni-collection d-lg-none mr-1" />
                      <Link className="text-grey" to="/innovations">
                        <span className="nav-link-inner--text">
                          <Determinator>
                            {{
                              en: "Innovations",
                              tw: "創新科技",
                              cn: "创新科技",
                            }}
                          </Determinator>
                        </span>
                      </Link>
                    </DropdownToggle>
                  </UncontrolledDropdown>
                  {/* <UncontrolledDropdown nav>
                    <DropdownToggle nav>
                      <i className="ni ni-collection d-lg-none mr-1" />
                      <Link className="text-grey" to="/contact_us">
                        <span className="nav-link-inner--text">
                          <Determinator>
                            {{
                              en: "Contact Us",
                              tw: "聯絡我們",
                              cn: "联络我们",
                            }}
                          </Determinator>
                        </span>
                      </Link>
                    </DropdownToggle>
                  </UncontrolledDropdown> */}

                </Nav>

                {/* <Nav className="align-items-lg-center ml-lg-auto" navbar>
                  <NavItem>
                    <NavLink
                      className="nav-link-icon"
                      href="https://www.facebook.com/creativetim"
                      id="tooltip333589074"
                      target="_blank"
                    >
                      <i className="fa fa-facebook-square" />
                      <span className="nav-link-inner--text d-lg-none ml-2">
                        Facebook
                      </span>
                    </NavLink>
                    <UncontrolledTooltip delay={0} target="tooltip333589074">
                      Like us on Facebook
                    </UncontrolledTooltip>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className="nav-link-icon"
                      href="https://www.instagram.com/creativetimofficial"
                      id="tooltip356693867"
                      target="_blank"
                    >
                      <i className="fa fa-instagram" />
                      <span className="nav-link-inner--text d-lg-none ml-2">
                        Instagram
                      </span>
                    </NavLink>
                    <UncontrolledTooltip delay={0} target="tooltip356693867">
                      Follow us on Instagram
                    </UncontrolledTooltip>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className="nav-link-icon"
                      href="https://twitter.com/creativetim"
                      id="tooltip184698705"
                      target="_blank"
                    >
                      <i className="fa fa-twitter-square" />
                      <span className="nav-link-inner--text d-lg-none ml-2">
                        Twitter
                      </span>
                    </NavLink>
                    <UncontrolledTooltip delay={0} target="tooltip184698705">
                      Follow us on Twitter
                    </UncontrolledTooltip>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className="nav-link-icon"
                      href="https://github.com/creativetimofficial/argon-design-system-react"
                      id="tooltip112445449"
                      target="_blank"
                    >
                      <i className="fa fa-github" />
                      <span className="nav-link-inner--text d-lg-none ml-2">
                        Github
                      </span>
                    </NavLink>
                    <UncontrolledTooltip delay={0} target="tooltip112445449">
                      Star us on Github
                    </UncontrolledTooltip>
                  </NavItem>
                  <NavItem className="d-none d-lg-block ml-lg-4">
                    <Button
                      className="btn-neutral btn-icon"
                      color="default"
                      href="https://www.creative-tim.com/product/argon-design-system-react?ref=adsr-navbar"
                      target="_blank"
                    >
                      <span className="btn-inner--icon">
                        <i className="fa fa-cloud-download mr-2" />
                      </span>
                      <span className="nav-link-inner--text ml-1">
                        Download
                      </span>
                    </Button>
                  </NavItem>
                </Nav> */}

              </UncontrolledCollapse>

            </Container>
            <div>
              {/* <tr >
                <td>EN</td> |
                <td>繁</td> |
                <td>简</td>
              </tr> */}
              <Row >
                <Col xs="3" className="text-white" onClick={() => { this.props.updateLanguageState({ lang: "en" }) }}>EN</Col>|
                <Col xs="3" className="text-white" onClick={() => { this.props.updateLanguageState({ lang: "tw" }) }}>繁</Col>|
                {/* <Col sm={{ size: 'auto', offset: -5 }}>简</Col> */}
                <Col xs="3" className="text-white" onClick={() => { this.props.updateLanguageState({ lang: "cn" }) }}>简</Col>
              </Row>
            </div>
          </Navbar>
        </header>

        <MultiLang lang={this.props.languageState.lang} />
      </>
    );
  }
}

export default DemoNavbar;
